<template>
  <el-aside width="250px" height="100%">
        <el-row class="tac">
          <el-menu
              :default-active="$route.path"
              class="el-menu-vertical-demo"
              :router= 'true'
            >
              <el-menu-item index="/" :select="flag">
                <i class="el-icon-back"></i>
                <span slot="title" >返回首页</span>
              </el-menu-item>
              <el-menu-item index="/compile/home">
                <i class="el-icon-files"></i>
                <span slot="title">主页数据</span>
              </el-menu-item>
              <el-menu-item index="/feedingStyle">
                <i class="el-icon-news"></i>
                <span slot="title">上料系统</span>
              </el-menu-item>
              <el-menu-item index="/blenderStyle">
                <i class="el-icon-bangzhu"></i>
                <span slot="title">搅拌机</span>
              </el-menu-item>
              <el-menu-item index="/coaterStyle">
                <i class="el-icon-crop"></i>
                <span slot="title">涂布机</span>
              </el-menu-item>
              <el-menu-item index="/rollerpressStyle">
                <i class="el-icon-guide"></i>
                <span slot="title">辊压机</span>
              </el-menu-item>
              <el-menu-item index="/slittingStyle">
                <i class="el-icon-female"></i>
                <span slot="title">分条机</span>
              </el-menu-item>
              <el-menu-item index="/cuttingStyle">
                <i class="el-icon-set-up"></i>
                <span slot="title">模切机</span>
              </el-menu-item>
              <el-menu-item index="/automaticStyle">
                <i class="el-icon-coin"></i>
                <span slot="title">叠片机</span>
              </el-menu-item>
              <el-menu-item index="/prewelderStyle">
                <i class="el-icon-money"></i>
                <span slot="title">预焊机</span>
              </el-menu-item>
              <el-menu-item index="/welderStyle">
                <i class="el-icon-link"></i>
                <span slot="title">终焊机</span>
              </el-menu-item>
              <el-menu-item index="/roasterStyle">
                <i class="el-icon-refrigerator"></i>
                <span slot="title">烘烤机</span>
              </el-menu-item>
              <el-menu-item index="/fillingStyle">
                <i class="el-icon-discount"></i>
                <span slot="title">注液预封机</span>
              </el-menu-item>
              <el-menu-item index="/formationStyle">
                <i class="el-icon-menu"></i>
                <span slot="title">化成机</span>
              </el-menu-item>
               <el-menu-item index="/sealStyle">
                <i class="el-icon-cpu"></i>
                <span slot="title">封口测试一体机</span>
              </el-menu-item>
              <el-menu-item index="/capperStyle">
                <i class="el-icon-receiving"></i>
                <span slot="title">抽气二封机</span>
              </el-menu-item>
              <el-menu-item index="/winderStyle">
                <i class="el-icon-files"></i>
                <span slot="title">卷绕机</span>
              </el-menu-item>
              <el-menu-item index="/loseStyle">
                <i class="el-icon-brush"></i>
                <span slot="title">负压化成机</span>
              </el-menu-item>
               <el-menu-item index="/machine_animation">
                <i class="el-icon-user"></i>
                <span slot="title">机器动画开关</span>
              </el-menu-item>
          </el-menu>
        </el-row>
      </el-aside>
</template>

<script>
export default {
computed:{
   tabFn3() {
      this.$router.push("/compile/home");
       // 这里可以传递一个值给父组件
      this.$emit('sendValue', 'Hello World!')
    },
    flag(){
      this.$store.commit("flagUpdate",3);
      this.$store.commit("homeTab", true);
      this.$emit("headTabFn", false);
      this.$store.commit("incrementFive",0);
       this.$emit('getchartData');
    },
}
}
</script>
<style lang= "less" scoped>
  .el-menu{
    height:100vh
}
</style>